import { render, staticRenderFns } from "./SplashingScreen.vue?vue&type=template&id=08bd908a"
import script from "./SplashingScreen.vue?vue&type=script&lang=js"
export * from "./SplashingScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports